import { render, staticRenderFns } from "./ImportModel.vue?vue&type=template&id=fe95af64&"
import script from "./ImportModel.vue?vue&type=script&lang=js&"
export * from "./ImportModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports